import { locationIdFormat } from "@redotech/redo-inventory-id";
import { processingSessionItemIdFormat } from "@redotech/redo-return-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

/** Step ids of a completed walk, minus backtracks, in order. */
export const ProcessingWalkPath = z.array(zExt.objectId());

export const finalizeProcessingSessionItem = {
  name: "finalizeProcessingSessionItem" as const,
  input: z.object({
    sessionItemId: processingSessionItemIdFormat.schema,
    path: ProcessingWalkPath,
    locationId: locationIdFormat.schema,
    workstationId: z.string().optional(),
  }),
  output: z.object({ session: ProcessingSession }),
};
